import ReactInputMask from "react-input-mask";

import styled, { css } from "styled-components";

const backgroundColor = ({ theme }) => {
  return theme.colors.neutral.white;
};

const disabledBackgroundColor = ({ theme }) => {
  return theme.colors.neutral.gray2;
};

const placeHolderColor = ({ theme }) => {
  return theme.colors.neutral.gray4;
};

const padding = ({ size }) => {
  switch (size) {
    case "xs":
      return "8px";
    case "lg":
      return "16px";

    case "sm":
    case "md":
    default:
      return "12px";
  }
};

const fontSize = ({ size }) => {
  switch (size) {
    case "xs":
      return "12px";
    case "sm":
      return "14px";
    case "lg":
      return "20px";

    case "md":
    default:
      return "16px";
  }
};

const outline = ({ state, theme }) => {
  switch (state) {
    case "success":
      return `1.5px solid ${theme.colors.feedbackState.success.default}`;
    case "warning":
      return `1.5px solid ${theme.colors.feedbackState.warning.default}`;
    case "error":
      return `1.5px solid ${theme.colors.feedbackState.critical.default}`;

    default:
      return `1px solid ${theme.colors.neutral.gray4}`;
  }
};

const focusBorderColor = ({ theme }) => {
  return theme.colors.feedbackState.info.hover;
};

const color = ({ disabled, theme }) => {
  if (disabled) return theme.colors.neutral.gray6;

  return theme.colors.primary.cetaceanBlue;
};

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  width: 100%;
  border: none;
  color: ${color};

  height: ${({ height }) => height || "auto"};

  grid-area: ${({ gridArea }) => gridArea};
  margin: ${({ margin }) => margin};
`;

export const Label = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  font-size: ${fontSize};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  line-height: 20px;
  letter-spacing: 0.02em;
  text-align: left;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  outline: ${outline};
  border-radius: 4px;

  &:focus-within {
    outline: 1.5px solid ${focusBorderColor};
  }

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      background-color: ${disabledBackgroundColor};
    `}
`;

export const RequiredDot = styled.div`
  margin: 2px 0;
  height: 4px;
  width: 4px;
  border-radius: 50%;
  background-color: ${({ theme }) =>
    theme.colors.feedbackState.critical.default};
`;

export const MaskedInputStyleStructure = styled(ReactInputMask)`
  padding: ${padding};
  background-color: ${backgroundColor};
  font-size: ${fontSize};
  border: none;
  border-radius: 4px;
  width: 100%;
  &:focus {
    outline: none;
  }

  &:disabled {
    cursor: not-allowed;
    background-color: ${disabledBackgroundColor};
  }

  &::placeholder {
    color: ${placeHolderColor};
  }
`;

export const InputStylesStructure = styled.textarea`
  padding: ${padding};
  background-color: ${backgroundColor};
  font-size: ${fontSize};
  border: none;
  border-radius: 4px;
  width: 100%;
  height: 100%;
  resize: none;
  &:focus {
    outline: none;
  }

  &:disabled {
    cursor: not-allowed;
    background-color: ${disabledBackgroundColor};
  }

  &::placeholder {
    color: ${placeHolderColor};
  }
`;
